import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';



const json = {
  1: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P17-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page17/E1/Key/answerKey.png',
    component: MatchDots,
    titleQuestion: [{ num: '1', title: 'Say the sound. Say the words. Match.', color: "#5B5A5D" }],

    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [

          { boxMatchStyle: { position: 'absolute', top: '135px', left: '145px', width: 138, height: 135 } },
          { boxMatchStyle: { position: 'absolute', top: '280px', left: '162px', width: 168, height: 135 } },
          { boxMatchStyle: { position: 'absolute', top: '425px', left: '162px', width: 168, height: 135 } },

          { boxMatchStyle: { position: 'absolute', top: '170px', left: '691px', width: 146, height: 56 } },
          { boxMatchStyle: { position: 'absolute', top: '244px', left: '691px', width: 146, height: 56 } },
          { boxMatchStyle: { position: 'absolute', top: '318px', left: '691px', width: 146, height: 56 } },
          { boxMatchStyle: { position: 'absolute', top: '392px', left: '705px', width: 166, height: 56 } },
          { boxMatchStyle: { position: 'absolute', top: '464px', left: '691px', width: 146, height: 56 } },
        ],
        answers: ['0-3', '0-5', '1-7', '2-6', '2-4'],
        initialValue: [],
      },
      Layout: `
          <img src='img/FriendsPlus/Page17/E1/1.jpg' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />

          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P17-E2',
    audio: '',
    video: '',
    component: D1,
    maxLength: 2,
    exerciseKey: 'img/FriendsPlus/Page17/E2/Key/answerKey.png',
    isAllowSubmit: false,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page17/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page17/E2/3.jpg', input: true, answer: "cr" },
        { url: 'img/FriendsPlus/Page17/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page17/E2/5.jpg', input: true, answer: "dr" },
        { url: 'img/FriendsPlus/Page17/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page17/E2/7.jpg', input: true, answer: "dr" },
        { url: 'img/FriendsPlus/Page17/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page17/E2/9.jpg', input: true, answer: "cr" },
        { url: 'img/FriendsPlus/Page17/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page17/E2/11.jpg', input: true, answer: "tr" },
        { url: 'img/FriendsPlus/Page17/E2/12.jpg' },
      ],

    ]
  },

  3: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P17-E3',
    audio: 'img/FriendsPlus/Page17/Audio/audio-e3-p17.mp3',
    video: '',
    component: D1,
    isAllowSubmit: true,
    exerciseKey: 'img/FriendsPlus/Page17/E3/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/2.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/tieude-e3-p17.mp3' },
        { url: 'img/FriendsPlus/Page17/E3/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page17/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page17/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/6.jpg', input: true, answer: "truck" },
        { url: 'img/FriendsPlus/Page17/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page17/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page17/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/10.jpg', input: true, answer: "crab" },
        { url: 'img/FriendsPlus/Page17/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/12.jpg', input: true, answer: "drum" },
        { url: 'img/FriendsPlus/Page17/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page17/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page17/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/16.jpg', input: true, answer: "crayons" },
        { url: 'img/FriendsPlus/Page17/E3/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page17/E3/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page17/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/20.jpg', input: true, answer: "dress" },
        { url: 'img/FriendsPlus/Page17/E3/21.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page17/E3/22.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page17/E3/23.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/24.jpg', input: true, answer: "tree" },
        { url: 'img/FriendsPlus/Page17/E3/25.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page17/E3/26.jpg' },
      ],
      [
        // Column13
        { url: 'img/FriendsPlus/Page17/E3/27.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/28.jpg', input: true, answer: "crayons" },
        { url: 'img/FriendsPlus/Page17/E3/29.jpg' },
      ],
      [
        // Column14
        { url: 'img/FriendsPlus/Page17/E3/30.jpg' },
      ],
    ]
  },

}

export default json;